import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-responsable-info',
  templateUrl: './responsable-info.component.html',
  styleUrls: ['./responsable-info.component.scss']
})
export class ResponsableInfoComponent implements OnInit {
  @Input() public responsable: any;
  /*civilite: "0"
civiliteLibelle: ""
email: null
id: "747"
lien_parente: "0"
nom: "HIELAN"
parenteLibelle: "Père"
prenom: "Thierry"
principal: "0"
tel_domicile: "0843659752"
tel_professionnel: "" 
tel_mobile*/

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/responsable/responsable-info/responsable-info.component.ts